import * as AOS from 'aos';

class ItemAnimate {
  constructor() {
    AOS.init({
      disable: 'mobile',
      duration: 500,
      easing: 'ease-out-quad'
    });

    AOS.refresh();
  }
}

const itemAnimate = new ItemAnimate();

// linear
// ease
// ease-in
// ease-out
// ease-in-out
// ease-in-back
// ease-out-back
// ease-in-out-back
// ease-in-sine
// ease-out-sine
// ease-in-out-sine
// ease-in-quad
// ease-out-quad
// ease-in-out-quad
// ease-in-cubic
// ease-out-cubic
// ease-in-out-cubic
// ease-in-quart
// ease-out-quart
// ease-in-out-quart
